import { DamageType } from "../damageType";
import type { Direction } from "../direction";
import { Explosion } from "../effects/explosion";
import type { ParticleEmitter } from "../interfaces";
import { ParticleType } from "../particleType";
import type { PhysicalThingWithHp } from "../physicalThingWithHp";
import { STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import { SimpleProjectile } from "../simpleProjectile";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";

export class CannonBullet extends SimpleProjectile implements ParticleEmitter {
	static key = "CannonBullet";

	getParticleType(): ParticleType {
		return ParticleType.BULLET_TRAIL;
	}

	protected damageTarget(target: PhysicalThingWithHp): number {
		return target.applyDamage(DamageType.EXPLOSION, STD_BASE_HP, this);
	}

	onHit(_damageDealt: number): void {
		this.board!.addNonPhysicalThing(new Sound(SoundId.EXPLOSION, this.xy));
		this.board!.addEffect(new Explosion(this.xy));
		this.board!.removeAtEndOfTurn(this);
	}

	static deserialize(data: any): CannonBullet {
		const bullet = new CannonBullet(deserializeXY(data.xy), data.direction as Direction);
		bullet.visualId = data.visualId;
		return bullet;
	}
}
